import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getUsers, updateUser } from '../api/users';
import { User } from '../types/user';
import toast from 'react-hot-toast';

export function useUsers() {
  return useQuery<User[]>({
    queryKey: ['users'],
    queryFn: getUsers,
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, user }: { userId: string; user: Partial<User> }) => updateUser(userId, user),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      toast.success('User updated successfully');
    },
    onError: (error) => {
      console.error('Error updating user:', error);
      toast.error('Failed to update user');
    },
  });
}

export function useResetUserPassword() {
  return useMutation({
    mutationFn: (userId: string) => updateUser(userId, { id: userId, reset_password: true }),
    onSuccess: () => {
      toast.success('Password reset email sent');
    },
    onError: (error) => {
      console.error('Error resetting user password:', error);
      toast.error('Failed to reset password');
    },
  });
}
